import React from 'react';
import './GeneralViewer.css';
import FieldViewer from './FieldViewer/FieldViewer'; 

/**
 * GeneralViewer component renders sections and subsections with their respective fields.
 * 
 * @param {Object} props - The props object containing the sections and language data.
 * @param {Object[]} props.data.Sections - An array of section objects.
 * @param {string} props.data.Sections[].Id - The unique identifier for the section.
 * @param {string} [props.data.Sections[].Title] - The title of the section.
 * @param {Object[]} [props.data.Sections[].Fields] - An array of field objects within the section.
 * @param {Object[]} [props.data.Sections[].SubSections] - An array of subsection objects within the section.
 * @param {string} props.language - The language to be used for displaying fields.
 * @returns {JSX.Element} The rendered GeneralViewer component.
 */
const GeneralViewer = (props) => {
    return (
        <div>
            {props.data.Sections.map((section) => (
                <div key={section.Id} className='generalviewer-sectioncontent'>
                    {section.Title ? ( 
                        <div className='generalviewer-sectiontitle'>
                            {section.Title}
                        </div>
                    ) : (
                        <div className='generalviewer-no-section-title'></div>
                    )}
                    {section.Fields?.length > 0 && ( 
                        <FieldViewer data={section.Fields} language={props.language} />
                    )}
                    {section.SubSections?.length > 0 && ( 
                        section.SubSections.map((subsection) => (
                            <div key={subsection.Id} className='generalviewer-subsectioncontent'>
                                {subsection.Title ? ( 
                                    <div className='generalviewer-subsectiontitle'>
                                        {subsection.Title}
                                    </div>
                                ) : null}
                                {subsection.Fields?.length > 0 && (
                                    <FieldViewer data={subsection.Fields} language={props.language} />
                                )}
                            </div>
                        ))
                    )}
                </div>
            ))}
            <br />
        </div>
    );
};

export default GeneralViewer;


